/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-05-14 08:34:02
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-17 15:01:16
 * @FilePath: \website\env.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const env = {
    baseUrl: '/designApi',
    // baseUrl: process.env.VUE_APP_API,
    fileUrl: '/file',
    version: '2.1.1',
    logoText: '大数据平台',
    yhfwUrl: process.env.VUE_APP_API,
    iconfont: '/iconfont',
    bladeXUrl: '/api',
    yulin: '/yulin',
    cengdeUrl: '/data'
}
export const baseUrl = env.baseUrl
export const fileUrl = env.fileUrl
export const yhfwUrl = env.yhfwUrl
export const iconfontUrl = env.iconfont
export const bladeXUrl = env.bladeXUrl
export const logoText = env.logoText
export const yulin = env.yulin
export const cengdeUrl = env.cengdeUrl
export default env

